import { render, staticRenderFns } from "./new-good-price.vue?vue&type=template&id=495b32c8&scoped=true"
import script from "./new-good-price.vue?vue&type=script&lang=js"
export * from "./new-good-price.vue?vue&type=script&lang=js"
import style0 from "./new-good-price.vue?vue&type=style&index=0&id=495b32c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b32c8",
  null
  
)

export default component.exports